import React from 'react';
import './Nav.css';
function Nav() {
    return (
        <div className='nav'>
            <div className="logo">
                <img src="AIPlanetLogo.png" alt="AIPlanetLogo" />
            </div>
        </div>
    );
}

export default Nav;
